import { useQuery } from '@tanstack/react-query';
import { userRateApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useUserRates() {
  return useQuery({
    queryKey: queryKeys.userRates.list(),
    queryFn: ({ signal }) => userRateApiClient.list({}, toCancelToken(signal)),
    staleTime: 5 * 60_000,
    meta: { errorContext: 'user rates' },
  });
}
